import { useState, useCallback } from 'react';
import {
  type OftalmologiaData,
  emptyOftalmologiaData,
} from './types';

export const useOftalmologiaForm = () => {
  const [oftalmologiaData, setOftalmologiaData] = useState<OftalmologiaData>(emptyOftalmologiaData);

  const setOftalmologiaField = useCallback(
    (section: keyof OftalmologiaData, field: string, value: any) => {
      setOftalmologiaData(prev => ({
        ...prev,
        [section]: {
          ...(prev[section] as any),
          [field]: value,
        },
      }));
    },
    [],
  );

  const loadFromConsultation = (rawData: any) => {
    const raw = (rawData as any)?.oftalmologia;
    if (!raw) return;

    const parsed: OftalmologiaData = {
      ...emptyOftalmologiaData,
      ...raw,
      visual_acuity: { ...emptyOftalmologiaData.visual_acuity, ...(raw.visual_acuity || {}) },
      refraction: { ...emptyOftalmologiaData.refraction, ...(raw.refraction || {}) },
      anterior_segment: { ...emptyOftalmologiaData.anterior_segment, ...(raw.anterior_segment || {}) },
      posterior_segment: { ...emptyOftalmologiaData.posterior_segment, ...(raw.posterior_segment || {}) },
      intraocular_pressure: { ...emptyOftalmologiaData.intraocular_pressure, ...(raw.intraocular_pressure || {}) },
      diagnosis_oft: { ...emptyOftalmologiaData.diagnosis_oft, ...(raw.diagnosis_oft || {}) },
      treatment_oft: { ...emptyOftalmologiaData.treatment_oft, ...(raw.treatment_oft || {}) },
    };

    setOftalmologiaData(parsed);
  };

  const getPayloadData = (): OftalmologiaData | null => {
    const hasData =
      oftalmologiaData.visual_acuity.sc_od !== '' ||
      oftalmologiaData.visual_acuity.sc_oi !== '' ||
      oftalmologiaData.refraction.sphere_od !== '' ||
      oftalmologiaData.anterior_segment.conjunctiva !== '' ||
      oftalmologiaData.posterior_segment.vitreous !== '' ||
      oftalmologiaData.intraocular_pressure.od !== null ||
      oftalmologiaData.diagnosis_oft.primary !== '' ||
      oftalmologiaData.treatment_oft.eye_drops !== '';
    return hasData ? oftalmologiaData : null;
  };

  return {
    oftalmologiaData,
    setOftalmologiaData,
    setOftalmologiaField,
    loadFromConsultation,
    getPayloadData,
  };
};
